<rds-drawer-container backdrop>
  <rds-drawer #drawer size="l" mode="overlay" (closeDrawer)="onDrawerClose()">
    <div id="detailed-view">
      <!-- Existing cases -->
      @if (detailType == DETAIL_TYPES.publication && detailData) {
        <app-publication-detail-view [publication]="$any(detailData)!" [isLoadingChanges]="isLoadingChanges" (newPublication)="onSubmit($event)"></app-publication-detail-view>
      }
      @else if (detailType == DETAIL_TYPES.ctmsMilestone) {
      <app-ctmsmilestone-detail-view [milestone]="$any(detailData)!" [isLoadingChanges]="isLoadingChanges" (newCTMSMilestone)="onSubmit($event)"></app-ctmsmilestone-detail-view>
    }
    @else if (detailType == DETAIL_TYPES.customMilestone) {
    <app-custom-milestone-detail-view [customMilestone]="$any(detailData)" [isLoadingChanges]="isLoadingChanges" (newCustomMilestone)="onSubmit($event)" (deleteCustomMilestone)="onDelete($event)"></app-custom-milestone-detail-view>
  }
  @else if (detailType == DETAIL_TYPES.activity) {
  <app-activity-detail-view [activity]="$any(detailData)!" [isLoadingChanges]="isLoadingChanges" (newActivity)="onSubmit($event)" (deleteActivity)="onDelete($event)"></app-activity-detail-view>
}
@else if (detailType == DETAIL_TYPES.vvpmActivity) {
<app-vvpm-activity-detail-view [vvpmActivity]="$any(detailData)!" [isLoadingChanges]="isLoadingChanges" (updateVVPMActivity)="onSubmitVVPMActivity($event)"></app-vvpm-activity-detail-view>
}
@else if (detailType == DETAIL_TYPES.congress) {
<app-congress-detail-view [congress]="$any(detailData)!"></app-congress-detail-view>
}
@else if (detailType == 'EXPORT_OPTIONS' && detailData) {
<div class="export-options-menu">
  <!-- Header with title -->
  <div class="menu-header">Create Google slide</div>

  <!-- Filter badges (displaying current filters) -->
  <div class="filter-badges">
    @for (chip of $any(detailData).filters?.chipValues || ['Banana','Strawberry']; track chip) {
      <rds-badge [label]="chip"></rds-badge>
    }
  </div>


  <!-- Export options content (checkboxes) -->
  <div class="export-options-content">
    @if (features.isEnabled('customActivities')) {
      <rds-checkbox name="exportActivities" [(ngModel)]="$any(detailData).options.exportActivities">
        Export Activities
      </rds-checkbox>
    }
    <rds-checkbox name="exportPublications" [(ngModel)]="$any(detailData).options.exportPublications">
      Export Publications
    </rds-checkbox>
    @if (features.isEnabled('ctmsMilestones')) {
      <rds-checkbox name="exportCtmsMilestones" [(ngModel)]="$any(detailData).options.exportCtmsMilestones">
        Export CTMS Milestones
      </rds-checkbox>
    }
    @if (features.isEnabled('customMilestones')) {
      <rds-checkbox name="exportManualMilestones" [(ngModel)]="$any(detailData).options.exportManualMilestones">
        Export Manual Milestones
      </rds-checkbox>
    }
    <rds-checkbox name="selectAll" [(ngModel)]="selectAllExport" (ngModelChange)="onSelectAllChange($event)">
      Select All
    </rds-checkbox>
  </div>

  <!-- Footer with info popovers, button, and link -->
  <div class="export-options-footer">
    <div class="info-popovers">
      <button rds-secondary-button #popover1="rdsPopover" (click)="popover1.toggle()" [rdsPopover]="popoverContent1">
        Storage
      </button>
      <ng-template #popoverContent1>
        <rds-popover-text-content>
          <h4 rds-popover-header>Slide Storage</h4>
          <p rds-popover-paragraph>Your slides will be saved in your GDrive (My drive)</p>
        </rds-popover-text-content>
      </ng-template>
      <button rds-secondary-button #popover2="rdsPopover" (click)="popover2.toggle()" [rdsPopover]="popoverContent2">
        Q&A
      </button>

      <ng-template #popoverContent2>
        <rds-popover-text-content>
          <h4 rds-popover-header>How Gslide generation works</h4>
          <p rds-popover-paragraph>
            GSlide generation automates the creation of Google Slides directly within Planwise.
            With a single click, it formats and structures the content into Roche branded slides.
            <a rds-link href="https://drive.google.com/file/d/1aRN1467IlpuqghbquvihrGi2ivjf_kgG/view?usp=sharing" target="_blank">
              📽 Watch Video
            </a>
          </p>

        </rds-popover-text-content>
      </ng-template>

    </div>
    <div class="create-gslide-button">
      <button rds-primary-button (click)="onExportGslide()">Create Gslide</button>
    </div>
  </div>

  <!-- Area for displaying the generated link -->
  @if (exportLink) {
    <div class="export-link">
      <p>Google Slide Link:
        <a rds-link [href]="exportLink" target="_blank">
          {{ exportLink }}
          <rds-icon namespace="filled" icon="chevron_right"></rds-icon>
        </a>
      </p>
    </div>
  }
</div>
}
@else if (detailType == DETAIL_TYPES.planwiseUser) {
<app-user-form
  [selectedUser]="$any(detailData)!"
  [isLoadingChanges]="isLoadingChanges"
  (submitUser)="onSubmitUser($event)"
  (deleteUser)="onDeleteUser($event)"
  (cancelForm)="drawer.close()">
</app-user-form>
}
@else if (detailType == DETAIL_TYPES.strategicPillar) {
<app-strategic-pillar-form
  [selectedStrategicPillar]="$any(detailData)!"
  [isLoadingChanges]="isLoadingChanges"
  (submitStrategicPillar)="onSubmitStrategicPillar($event)"
  (deleteStrategicPillar)="onDeleteStrategicPillar($event)"
  (cancelForm)="drawer.close()">
</app-strategic-pillar-form>
}
@else if (detailType == DETAIL_TYPES.audience) {
<app-audience-form
  [selectedAudience]="$any(detailData)!"
  [isLoadingChanges]="isLoadingChanges"
  (submitAudience)="onSubmitAudience($event)"
  (deleteAudience)="onDeleteAudience($event)"
  (cancelForm)="drawer.close()">
</app-audience-form>
}

<!-- Loading overlay -->
@if (isLoadingExport) {
  <div class="progress-overlay">
    <rds-progress-spinner label="Loading..." mode="indeterminate" size="xl"></rds-progress-spinner>
  </div>
}
</div>
</rds-drawer>
<rds-drawer-content>
  <ng-content></ng-content>
</rds-drawer-content>
</rds-drawer-container>
